export default __webpack_public_path__ + "static/media/alaska.bfdc1c7d.jpg";